import { TOCOrderType, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
export const eqProducts = [
    { title: "CNC", value: "CNC", rank: 1 },
    { title: "NRML", value: "NRML", rank: 2 },
    { title: "MTF", value: "MTF", rank: 4 },
    { title: "MIS", value: "MIS", rank: 5 },
    { title: "BO", value: "BO", rank: 7 },
    { title: "NRML", value: "M", rank: 3 },
    { title: "MIS", value: "I", rank: 6 },
];
export const eqOrder = [
    { title: "MARKET", value: "MARKET", rank: 1 },
    { title: "LIMIT", value: "LIMIT", rank: 2 },
    { title: "SL", value: "STOP_LIMIT", rank: 3 },
    // { title: "SL-M", value: "STOP_MARKET", rank: 4 },
];
export const eqValidity = [
    { title: "Day", value: "DAY", rank: 1 },
    { title: "IOC", value: "IOC", rank: 2 },
];
export var TOCSectionSelectedtype;
(function (TOCSectionSelectedtype) {
    TOCSectionSelectedtype["PRODUCT"] = "PRODUCT";
    TOCSectionSelectedtype["ORDER"] = "ORDER";
    TOCSectionSelectedtype["VALIDITY"] = "VALIDITY";
    TOCSectionSelectedtype["FREQUENCY"] = "FREQUENCY";
    TOCSectionSelectedtype["INVESTMENT"] = "INVESTMENT";
    TOCSectionSelectedtype["SCHEMETYPE"] = "SCHEMETYPE";
    TOCSectionSelectedtype["RETURNOPTION"] = "RETURNOPTION";
    TOCSectionSelectedtype["DIVFREQUENCY"] = "DIVFREQUNECY";
    TOCSectionSelectedtype["ALERTS"] = "ALERTS";
    TOCSectionSelectedtype["MFFIRSTINSTALLMENT"] = "MFFIRSTINSTALLMENT";
    TOCSectionSelectedtype["REDEEMMODE"] = "REDEEMMODE";
    TOCSectionSelectedtype["REDEEMBY"] = "REDEEMBY";
})(TOCSectionSelectedtype || (TOCSectionSelectedtype = {}));
export const ClickOnLimitField = [
    {
        source: TOCOrderType.MARKET,
        destination: TOCOrderType.LIMIT,
    },
    // {
    //   source: TOCOrderType.SL,
    //   destination: TOCOrderType.SL,
    // },
];
